import React from 'react';

const InstagramMusic = (
  { width = 20, height = 20, color = 'var(--icon-default)', ...rest },
  ref
) => {
  return (
    <svg
      {...rest}
      ref={ref}
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9.99996 18.3327C6.07159 18.3327 4.1074 18.3327 2.88701 17.1123C1.66663 15.8919 1.66663 13.9277 1.66663 9.99935C1.66663 6.07098 1.66663 4.10679 2.88701 2.8864C4.1074 1.66602 6.07159 1.66602 9.99996 1.66602C13.9283 1.66602 15.8925 1.66602 17.1129 2.8864C18.1469 3.92042 18.3048 5.48841 18.3289 8.33268"
        stroke={color}
        strokeWidth="1.25"
        strokeLinecap="round"
      />
      <path d="M15.8334 16.6667V13.3333V10" stroke={color} strokeWidth="1.25" strokeLinecap="round" />
      <circle cx="14.1667" cy="16.6667" r="1.66667" stroke={color} strokeWidth="1.25" />
      <path
        d="M18.3334 12.5C16.9527 12.5 15.8334 11.3807 15.8334 10"
        stroke={color}
        strokeWidth="1.25"
        strokeLinecap="round"
      />
      <path
        d="M7.5 10C7.5 8.61929 8.61929 7.5 10 7.5C11.3807 7.5 12.5 8.61929 12.5 10C12.5 11.3807 11.3807 12.5 10 12.5C8.61929 12.5 7.5 11.3807 7.5 10Z"
        stroke={color}
        strokeWidth="1.25"
      />
    </svg>
  );
};

export default React.forwardRef(InstagramMusic);
